<script setup lang="ts">
withDefaults(
  defineProps<{
    id: string
    content: string
    title: string
    titleIsHidden?: boolean
  }>(),
  {
    titleIsHidden: false,
  },
)

const emit = defineEmits<{
  click: [MouseEvent]
}>()
</script>

<template>
  <section @click="emit('click', $event)">
    <h2
      :id="id"
      class="heading-5"
      :class="{ 'sr-only': titleIsHidden }"
    >
      {{ title }}
    </h2>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="content" />
  </section>
</template>
